angular.module('CarsSaraBo').factory('PickupPointService', ['$resource', function ($resource) {
    return $resource('../rest/company/:companyOid/pickupPoint/:oid',
        {
            companyOid: '@companyOid',
            oid: '@oid'
        },
        {
            update: {method: 'PUT'},
            getAll: {method: 'GET', isArray: true},
            save: {method: 'POST'}
        }
    )
}]);

angular.module('CarsSaraBo').factory('PickupPointServiceAll', ['$resource', function ($resource) {
    return $resource('../rest/company/:companyOid/pickupPoint/all',
        {
            companyOid: '@companyOid'
        },
        {
            remove: {method: 'DELETE'}
        }
    )
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/pickupPoint_service.js
// module id = 858
// module chunks = 3